export interface LoginProvider {
  onLoginSuccess: (response: any) => void;
  onLoginFail: (response: any) => void;
  onForgotSuccess: (response: any) => void;
  onForgotFail: (response: any) => void;
  onResetSuccess: (response: any) => void;
  onResetFail: (response: any) => void;
  onTwoFactorLoginSuccess: (response: any) => void;
  onTwoFactorLoginFail: (response: any) => void;
}
